export const serviceNameFieldsData = {
    name: {
        name: "name",
        label: "AI Service Name",
        maxCount: 50,
        description: "The name of your service has to be unique within your organization",
    },
    newId: {
        name: "newId",
        label: "AI Service Id",
        maxCount: 32,
        description:
            "The ID of your service has to be unique withing your organization. After clicking the continue button, it is unavailable for editing.",
    },
};

export const serviceDescriptionFieldsData = [
    {
        infoMessage:
            "A short description about your service, which shouldn't be more then 160 character.",
        name: "shortDescription",
        label: "Short Description",
        maxCount: 160,
        rowCount: 3,
        colCount: 105,
        required: true,
    },
    {
        infoMessage:
            "A long description, giving some brief details about your service, which shouldn't be more then 5000 character.",
        name: "longDescription",
        label: "Long Description",
        maxCount: 5000,
        rowCount: 8,
        colCount: 105,
        required: true,
    },
];

export const serviceAdditionalInfoFieldsData = [
    {
        name: "projectURL",
        label: "Project URL",
        description:
            "The website URL of the service will be displayed to users under your AI service page. GitHub links are recommended.",
        required: true,
    },
    {
        infoMessage: "Name of all the contributors for this service",
        name: "contributors",
        label: "Contributors",
        maxCount: 100,
        required: true,
    },
];
